export default "__VITE_ASSET__BJr4MtCa__"